import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../core/breadcrumbs";
import { Link } from "react-router-dom";
import {  Edit, Eye, Trash2 } from "react-feather";
import ImageWithBasePath from "../../core/img/imagewithbasebath";

import { Table } from "antd";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import SupplierModal from "../../core/modals/peoples/supplierModal";

import axios from "axios";

const Suppliers = () => {

  const [selectedSupplierId, setSelectedSupplierId] = useState(null);
  
  const [suppliers, setSuppliers] = useState([]);

  const [shouldReloadData, setShouldReloadData] = useState(false);

  const storedUserData = localStorage.getItem("user");
  const userData = JSON.parse(storedUserData);
  const roleName = userData?.data.role.roleName;

  useEffect(() => {
    fetchSuppliers();
  }, [shouldReloadData]);

  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(`/suppliers`);
      if (!response) {
        throw new Error("Failed to fetch suppliers");
      }
      const data = await response.data;
      //console.log("Fetched data:", data);
      setSuppliers(data.data.suppliers);
    } catch (error) {
      Swal.fire({
                      title: "Error!",
                      text: "Error fetching suppliers",
                      icon: "error",
                  })
    }
  };

  const handleReloadData = () => {
    setShouldReloadData(!shouldReloadData);
  };


  const columns = [
    {
      render: () => (
        <label className="checkboxs">
          <input type="checkbox" />
          <span className="checkmarks" />
        </label>
      ),
    },

    {
      title: "Supplier Name",
      dataIndex: "SupplierName",
      sorter: (a, b) => a.supplierName.length - b.supplierName.length,
    },
    {
      title: "Code",
      dataIndex: "Code",
      sorter: (a, b) => a.code.length - b.code.length,
    },

    {
      title: "Email",
      dataIndex: "Email",
      sorter: (a, b) => a.email.length - b.email.length,
    },

    {
      title: "Phone",
      dataIndex: "Phone",
      sorter: (a, b) => a.phone.length - b.phone.length,
    },

    {
      title: "Country",
      dataIndex: "Country",
      sorter: (a, b) => a.country.length - b.country.length,
    },

    {
      title: "Action",
      dataIndex: "action",
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (supplierId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        deleteSupplier(supplierId);
        MySwal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          className: "btn btn-success",
          confirmButtonText: "OK",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      } else {
        MySwal.close();
      }
    });
  };

  const deleteSupplier = async (supplierId) => {
    try {
       await axios.delete(
        `/suppliers/${supplierId}`);
        handleReloadData();
      
    } catch (error) {
      console.error("Error deleting customer:", error);
      Swal.fire({
                      title: "Error!",
                      text: "Cannot Delete Supplier",
                      icon: "error",
                  });
    }
  };

  const handleLinkClick = async (supplierId) => {
    setSelectedSupplierId(supplierId);
  };

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const filteredSuppliers = suppliers.filter((suplier) => {
    const searchLower = searchQuery.toLowerCase();
    return suplier.supplierName.toLowerCase().includes(searchLower);
  });

  return (
    <div className="page-wrapper">
      <div className="content">
        <Breadcrumbs
          maintitle="Supplier List "
          subtitle="Manage Your Supplier"
          addButton="Add New Supplier"
        />

        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <div className="search-input">
                  <input
                    type="search"
                    className="form-control form-control-sm formsearch"
                    value={searchQuery}
                    placeholder="Search By Name"
                    onChange={handleSearchInputChange}
                  />
                  <Link to className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </Link>
                </div>
              </div>
              
             
            </div>
            {/* /Filter */}
            
            {/* /Filter */}
            <div className="table-responsive">
              {/* <Table
                className="table datanew"
                columns={columns}
                dataSource={data}
                rowKey={(record) => record.id}
                // pagination={true}
              /> */}
              <Table
                className="table datanew"
                columns={columns}
                dataSource={filteredSuppliers.map((supplier) => ({
                  key: supplier._id,
                  SupplierName: (
                    <span className="productimgname">
                      <Link to="#" className="product-img stock-img">
                        <ImageWithBasePath alt="" src={supplier.supplierImage} />
                      </Link>
                      <Link to="#">{supplier.supplierName}</Link>
                    </span>
                  ),
                  Code: `#${supplier._id.slice(-3)}`,
                  Email: supplier.supplierEmail,
                  Phone: supplier.supplierPhone,
                  Country: supplier.supplierCountry,
                  action: (
                    <td className="action-table-data">
                      <div className="edit-delete-action">
                        <div className="input-block add-lists"></div>

                        <Link className="me-2 p-2" to="#"
                        data-bs-toggle="modal"
                          data-bs-target="#view-units"
                          onClick={() => handleLinkClick(supplier._id)}
                        >
                          <Eye className="feather-view" />
                        </Link>

                        <Link
                          className="me-2 p-2"
                          to="#"
                          data-bs-toggle="modal"
                          data-bs-target="#edit-units"
                          onClick={() => handleLinkClick(supplier._id)}
                        >
                          <Edit className="feather-edit" />
                        </Link>

                        {roleName === "Admin" && (
                          <Link
                            className="confirm-text p-2"
                            to="#"
                            onClick={() => showConfirmationAlert(supplier._id)}
                          >
                            <Trash2 className="feather-trash-2" />
                          </Link>
                        )}
                      </div>
                    </td>
                  ),
                }))}
                pagination={false}
              />
            </div>
          </div>
        </div>
        {/* /product list */}
      </div>

      <SupplierModal
        onSupplierAdded={handleReloadData}
        supplierId={selectedSupplierId}
      />
    </div>
  );
};

export default Suppliers;
